import { useSearchParamsSync } from "../hooks/useSearchParamsSync";

/**
 * Functional wrapper for useSearchParamsSync.
 *
 * @param {Object} request - current request object
 */
export const SearchParamsSyncWrapper = ({ request }) => {
  useSearchParamsSync(request);
  return null;
};
